import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { currentBoardIdSelector } from '../../../../store/selectors/selectors'
import { compose, withHandlers } from 'recompose'
import { goToBoard } from '../../../../store/actions/boards'
import { setEditingItem } from '../../../../store/actions/sidebar'
import {
  sidebarDragSelector,
  editingItemSelector,
  getFoldersSelector
} from '../../../../store/selectors/accessSelectors'
import { EDITOR } from 'app/constants'
import { smallScreenSelector } from '../../../../store/selectors/boardSelectors'
import getUrl from '../../../../utils/getUrl'
import { userSelector } from '../../../../store/selectors/baseSelectors';

const SidebarRowContainer = compose(
  connect(
    (state, { item, selected, index }) => {
      const drag = sidebarDragSelector(state)
      const getFolders = getFoldersSelector(state)
      let dropLocation = null
      if (drag.id) {
        // drop in this folder
        if (drag.folder === item.id) {
          if (drag.notAllowed) dropLocation = 'notAllowed'
          else dropLocation = 'inside'
        } else if (index === 0 && drag.order === 0)
          // drop before first item
          dropLocation = 'before'
        else if (index !== undefined && drag.order === index + 1)
          // drop after this item
          dropLocation = 'after'
        // drop somewhere, but not relivant to this item
        else dropLocation = 'other'
      }
      return {
        anon: userSelector(state).isAnonymous,
        getFolders: getFolders,
        smallScreen: smallScreenSelector(state),
        editing: editingItemSelector(state) === item.id,
        selected: selected || currentBoardIdSelector(state) === item.id,
        dropLocation: dropLocation
      }
    },
    {
      goToBoard,
      push,
      setEditingItem
    }
  ),
  withHandlers({
    onClick: ({ item, goToBoard, push }) => () =>
      item.type === 'board' ? goToBoard(item) : push(getUrl(item)),
    edit: ({ item, setEditingItem }) => () =>
      item.accessLevel >= EDITOR && setEditingItem(item.id),
    editDone: ({setEditingItem}) => () => setEditingItem(null)
  })
)

export default SidebarRowContainer
